import { render, staticRenderFns } from "./SepaTable.vue?vue&type=template&id=185c44f1&scoped=true"
import script from "./SepaTable.vue?vue&type=script&lang=js"
export * from "./SepaTable.vue?vue&type=script&lang=js"
import style0 from "./SepaTable.vue?vue&type=style&index=0&id=185c44f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185c44f1",
  null
  
)

export default component.exports